import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import DashboardLogin from "./pages/dashboard/DashboardLogin";
import DashboardSignup from "./pages/dashboard/DashboardSignup";
import DashboardLayout from "./pages/dashboard/DashboardLayout";
import DashboardOverview from "./pages/dashboard/DashboardOverview";
import DashboardContacts from "./pages/dashboard/DashboardContacts";
import DashboardBookings from "./pages/dashboard/DashboardBookings";
import DashboardIntegrations from "./pages/dashboard/DashboardIntegrations";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./i18n/LanguageContext";
import LanguagePicker from "./components/site/LanguagePicker";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/dashboard/login" element={<DashboardLogin />} />
              <Route path="/dashboard/signup" element={<DashboardSignup />} />
              <Route path="/dashboard" element={<DashboardLayout />}>
                <Route index element={<DashboardOverview />} />
                <Route path="contacts" element={<DashboardContacts />} />
                <Route path="bookings" element={<DashboardBookings />} />
                <Route path="integrations" element={<DashboardIntegrations />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <LanguagePicker />
          <Toaster />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
